import { useState, type ReactNode } from "react";
import { errorMessage } from "../../lib/format";
import { Button } from "./Button";
import { Dialog } from "./Dialog";

/** Confirmation for destructive actions; shows the server error inline if the action fails. */
export function ConfirmDialog({
  open, onOpenChange, title, description, confirmLabel = "Confirm", destructive = true, onConfirm,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description: ReactNode;
  confirmLabel?: string;
  destructive?: boolean;
  onConfirm: () => Promise<unknown>;
}) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const confirm = async () => {
    setBusy(true);
    setError(null);
    try {
      await onConfirm();
      onOpenChange(false);
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog
      open={open}
      onOpenChange={(o) => { if (!busy) { setError(null); onOpenChange(o); } }}
      title={title}
      description={description}
      size="sm"
      footer={
        <>
          <Button onClick={() => onOpenChange(false)} disabled={busy}>Cancel</Button>
          <Button variant={destructive ? "danger" : "primary"} onClick={confirm} loading={busy}>{confirmLabel}</Button>
        </>
      }
    >
      {error && <p role="alert" className="rounded-xl bg-rose-500/10 p-2 text-sm text-rose-700 ring-1 ring-inset ring-rose-500/20">{error}</p>}
    </Dialog>
  );
}
